import React from 'react';
import { PhoneCall, Phone, User, Shield } from 'lucide-react';
import PageHeader from './ui/PageHeader';
import { maskPhoneNumber } from '../utils/auth';

const CONTACTS = [
  { phone: '+905434577082', name: 'Şamil Namlı' },
  { phone: '+905350226590', name: 'Erkin Ünlü' },
];

const formatDisplayPhone = (phone) => {
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('90')) {
    return `+90 ${digits.slice(2, 5)} ${digits.slice(5, 8)} ${digits.slice(8, 10)} ${digits.slice(10)}`;
  }
  return phone;
};

const ContactCard = ({ contact, isAdmin }) => {
  const displayPhone = isAdmin ? formatDisplayPhone(contact.phone) : maskPhoneNumber(contact.phone);

  return (
    <div className="group relative overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03] p-5 ring-1 ring-white/5 transition-all hover:border-accent-400/20 hover:bg-white/[0.05]">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-6 -top-6 h-24 w-24 rounded-full bg-accent-400/5 blur-2xl transition-opacity group-hover:opacity-100 opacity-60"
      />
      <div className="relative flex items-start gap-4">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-accent-400/10 ring-1 ring-accent-400/20">
          <User className="h-5 w-5 text-accent-300" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-base font-semibold text-white">{contact.name}</p>
          <div className="mt-2 flex items-center gap-2">
            <Phone className="h-4 w-4 shrink-0 text-slate-500" />
            {isAdmin ? (
              <a
                href={`tel:${contact.phone}`}
                className="font-mono text-sm text-accent-200 transition-colors hover:text-accent-100"
              >
                {displayPhone}
              </a>
            ) : (
              <span className="font-mono text-sm text-slate-400">{displayPhone}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const Contact = ({ isAdmin = false }) => (
  <div className="page-container">
    <PageHeader
      title="İletişim"
      description="Demo ve geliştirme sürecinde destek almak veya bizimle iletişime geçmek için aşağıdaki numarayı kullanabilirsiniz."
    />

    <div className="card relative overflow-hidden">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-gradient-to-br from-accent-400/[0.06] via-transparent to-transparent"
      />
      <div className="relative">
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-400/15 ring-1 ring-accent-400/25">
            <PhoneCall className="h-5 w-5 text-accent-300" />
          </div>
          <div>
            <h3 className="font-semibold text-white">Destek ekibi</h3>
            <p className="text-sm text-slate-400">Teknik destek ve demo süreci</p>
          </div>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          {CONTACTS.map((contact) => (
            <ContactCard key={contact.phone} contact={contact} isAdmin={isAdmin} />
          ))}
        </div>

        {!isAdmin && (
          <div className="mt-6 flex items-start gap-2 rounded-xl border border-white/10 bg-white/[0.02] px-4 py-3 text-sm text-slate-400">
            <Shield className="mt-0.5 h-4 w-4 shrink-0 text-slate-500" />
            <p>
              Telefon numaraları gizlilik nedeniyle kısmen maskelenmiştir. Tam numarayı görmek için
              yönetici olarak giriş yapın.
            </p>
          </div>
        )}
      </div>
    </div>
  </div>
);

export default Contact;
